<app-other-products-card *ngFor="let product of products; let i = index"
                         [product]="product"
                         className="single-item"
                         [index]="i + 1"
></app-other-products-card>
